export const titleFormatter = (item) => {
  return item.replace(/[^A-Za-z0-9]/g, " ").toUpperCase();
};